import { atom } from "jotai";

export interface IPurchaseOrderLine {
    id?: number;
    purchase_order_id: number;
    trackable_item_id: string;
    order_stock_qty?: number;
    order_unit_qty?: number;
    unit_cost?: number | null;
    currency?: string | null;
}

export interface IPurchaseOrderLineInput extends Omit<IPurchaseOrderLine, 'id'> {}

export const purchaseOrderLinesAtom = atom<IPurchaseOrderLine[]>([]);
export const purchaseOrderLinesLoadingAtom = atom<boolean>(false);

